<template lang='pug'>
#moda-divergencia-localidade
    el-dialog(
        :visible.sync='show',
        :show-close="false"
        :close-on-click-modal='false'
    )
        i.icone.lyra-error

        h1 {{ $t('mensagens.territorio.modalDivergenciaTitulo') }}
        p {{ $t('mensagens.territorio.modalDivergenciaExplicacao') }}
        h2 {{ $t('mensagens.territorio.modalDivergenciaRegistrarFinca') }}

        .moda-divergencia-localidade__footer(slot='footer')
            .buttons
                el-button(
                    type='default',
                    @click='deleteTerritory(indexTerritorioDivergente)'
                )
                    | {{ $t('mensagens.comuns.voltar') }}
                el-button(type='primary', @click='$emit("close")')
                    | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'ModalDivergenciaLocalidade',
    emits: ['close'],
    props: {
        show: {
            type: Boolean,
            required: true
        },
        indexTerritorioDivergente: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapGetters(['territoryTableData'])
    },
    methods: {
        ...mapActions([
            'removeTerritoryTableData'
        ]),
        deleteTerritory(index) {
            if (this.territoryTableData[index].type === 'UPLOAD') {
                this.$emit(
                    'delete-upload-file',
                    this.territoryTableData[index].fileName
                );
            } else {
                this.$root.$emit(
                    'remove-map-layer',
                    this.territoryTableData[index].identificadorGeometria
                );
                this.removeTerritoryTableData(index);
            }
            this.$emit('click-delete-area');
        }
    }
};
</script>

<style lang='scss'>
#moda-divergencia-localidade {

    .el-dialog {
        width: 70% !important;
    }

    .moda-divergencia-localidade__footer {
        display: contents;
    }

    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: flex-end;
        }
    }

    .el-dialog__body {
        display: flex;
        flex-direction: column;
        align-items: center;
        word-break: break-word;
    }

    .icone {
        display: flex;
        justify-content: center;
        padding: 25px;
    }

    .icone::before {
        content: '';
        width: 60px;
        height: 60px;
        display: inline-block;
        background-color: var(--yellow);
    }
}
</style>
